export const EDIT = 'EDIT';
export const ADD_QC = 'ADD_QC';
export const ACCEPT_MQL = 'ACCEPT_MQL';
export const ACCEPT_MQL_AAA = 'ACCEPT_MQL_AAA';
export const DECLINE_MQL = 'DECLINE_MQL';
export const ACCEPT_SAL = 'ACCEPT_SAL';
export const DECLINE_SAL = 'DECLINE_SAL';
